import * as React from "react";

const SvgLogout = ({ ...props }) => {

    return (
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
     width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000"
     preserveAspectRatio="xMidYMid meet"
     {...props}
     >
    
    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
    fill="currentColor" stroke="none">
   <path d="M2460 5104 c-100 -36 -178 -116 -206 -212 -11 -36 -14 -165 -14 -628
0 -572 0 -584 21 -641 100 -265 472 -275 592 -15 22 47 22 53 22 657 l0 610
-26 56 c-52 111 -150 178 -273 185 -50 3 -84 0 -116 -12z"/>
<path d="M1410 4375 c-112 -31 -410 -258 -573 -438 -223 -246 -397 -539 -497
-837 -207 -619 -150 -1306 155 -1865 343 -630 938 -1063 1640 -1194 508 -95
1020 -21 1487 216 618 313 1063 882 1223 1564 74 317 76 712 5 1028 -133 597
-491 1119 -991 1448 -150 98 -244 113 -364 59 -68 -31 -115 -74 -151 -138 -27
-49 -29 -61 -29 -153 0 -84 4 -107 22 -140 27 -50 89 -110 173 -165 343 -228
598 -590 700 -993 42 -166 53 -282 48 -485 -6 -194 -30 -329 -90 -501 -211
-605 -752 -1042 -1395 -1126 -722 -95 -1443 299 -1753 958 -228 486 -220 1035
21 1508 129 251 335 483 574 644 95 64 132 101 162 160 35 67 42 172 18 244
-52 156 -226 249 -385 206z"/>
    </g>
    </svg>)
};

export default SvgLogout;